// @flow

// Types
import type {
  Shape,
} from 'fc-flow-types/models'

import type {
  Feature,
  Geometry,
} from 'fc-flow-types/geoJSON'

// Libs
import React from 'react'
import _size from 'lodash/size'

// Components
import GeoJsonSvg from 'fc-geojson-svg'
import LocationIcon from 'fc-icons/src/Location'

// Turf
import { coordAll } from '@turf/meta'

// Styles
import { primary } from 'fc-styles/src/colors'

// Types
type Props = {
  shape?: Shape,
  geoJSON?: Object
}

// Local Types
type PostProcessResult = {
  style: (style: string, value: string) => PostProcessResult
}

// Exports
export default function ShapeSvg ({ shape, geoJSON, ...restProps }: Props): ?React.Element<any> {
  if ((!shape || !shape.shapeData) && !geoJSON) {
    return null
  }

  let data = geoJSON

  if (!data) {
    const { shapeData }: { shapeData: Feature<Geometry<Object>, Object> } = shape
    data = shapeData
  }

  const coords: Array<[number, number]> = coordAll(data)

  if (_size(coords) >= 2) {
    return (
      <GeoJsonSvg
        height={'35px'}
        {...restProps}
        data={data}
        postProcess={function (result: PostProcessResult) {
          result
            .style('fill', '#f5d780')
            .style('stroke', primary())
            .style('stroke-width', '1px')
        }}
      />
    )
  } else if (_size(coords) === 1) {
    return (
      <LocationIcon color={primary()} size={18} />
    )
  } else {
    return null
  }
}
